import React, {
  useState,
  useEffect,
  useRef,
} from 'react';
import PropTypes from 'prop-types';

import { formatSeconds, TagListFromTagHighlights, TextHighlighted } from '@playbookux/playbook-web-core';

import {
  Container,
  ContainerTranscript,
  Edit,
  Field,
  Icon,
  Speaker,
  Text,
  TimeLink,
} from './styles';

const Transcript = (props) => {
  const {
    id,
    speakerTag,
    startTime,
    endTime,
    transcript,
    tagHighlights,
    onSubmit,
    onCurrentTime,
    onRemoveTagHighlight,
    transcriptHighlights,
  } = props;

  const inputEl = useRef(null);

  const [readOnly, setReadOnly] = useState(true);
  const [value, setValue] = useState('');
  const [initialValue, setInitialValue] = useState('');

  useEffect(() => {
    if (!value && !initialValue) {
      setValue(transcript);
      setInitialValue(transcript);
    }
  }, [value, initialValue, transcript]);

  const handleEdit = () => {
    setReadOnly(false);
  };

  const handleChange = (event) => {
    setValue(event.target.value);
  };

  const handleCancel = () => {
    setValue(initialValue);
    setReadOnly(true);
  };

  const handleSubmit = () => {
    onSubmit(value);
    setReadOnly(true);
  };

  const handleCurrentTime = () => {
    onCurrentTime(startTime);
  };

  return (
    <div
      data-transcript-video-start-time={startTime}
      data-transcript-video-end-time={endTime}
    >
      <Container
        dataId={readOnly ? id : ''}
        dataEntity="TestSessionSpeaker"
      >
        <Speaker>
          {speakerTag.length > 1 ? `${speakerTag}` : `Speaker ${speakerTag}`}
          <TimeLink onClick={handleCurrentTime}>
            {/* do not erase empty space! */}
            {` (${formatSeconds(startTime)})`}
          </TimeLink>
        </Speaker>

        <Text>
          {readOnly && (
            <ContainerTranscript>
              <TextHighlighted
                tagHighlights={tagHighlights}
                transcriptHighlights={transcriptHighlights}
                text={value}
              />
            </ContainerTranscript>
          )}
          {
            readOnly && (
              <Edit
                onClick={handleEdit}
              >
                &nbsp;Edit
              </Edit>
            )
          }

          {!readOnly && (
            <>
              <Field
                value={value}
                onChange={handleChange}
                readOnly={readOnly}
                ref={inputEl}
              />
              <Icon name="check" color="green" onClick={handleSubmit} />
              <Icon name="close" color="red" onClick={handleCancel} />
            </>
          )}
        </Text>

        <TagListFromTagHighlights
          tagHighlights={tagHighlights}
          onRemoveTagHighlight={(...args) => onRemoveTagHighlight(id, ...args)}
          marginBottom="10px"
        />
      </Container>
    </div>
  );
};

Transcript.propTypes = {
  id: PropTypes.string.isRequired,
  speakerTag: PropTypes.string.isRequired,
  startTime: PropTypes.number.isRequired,
  endTime: PropTypes.number.isRequired,
  transcript: PropTypes.string.isRequired,
  onCurrentTime: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onRemoveTagHighlight: PropTypes.func.isRequired,
  tagHighlights: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  transcriptHighlights: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default Transcript;
